import { RegisterPage } from '@/containers';

export const Register = () => {
  return <RegisterPage />;
};
